module.exports = __webpack_public_path__ + "img/5.212ea252.png";